<template>
  <el-form
    :model="result.form"
    :ref="refForm"
    :rules="rules"
    :label-width="VW(labelWidth)"
    :label-position="labelPosition"
    :style="{'width': VW(formWidth), 'background-color': formBGC}"
    :class="center ? 'flex-center flex-wrap' : 'flex-wrap'"
  >
    <div
      v-for="(item,index) in (result.option || option)"
      :key="item.index"
      :draggable="FALSE(draggable)"
      @dragenter="dragenter($event, item,index)"
      @dragend="dragend($event,item,index)"
      @dragstart="dragstart($event,item,index)"
      @click="click($event,item,index)"
    >
      <el-form-item
        v-if="item.type && TRUE(item.show)"
        :class="itemClass(item)"
        :label="item.label"
        :prop="item.prop"
        :label-width="VW(item.labelWidth)"
        :required="FALSE(item.required)"
      >
        <slot v-if="item.type === 'slot'" :name="item.slotName || 'default'" :data="{form:result.form,item}"/>
        <el-tooltip v-if="item['hintLeft']" placement="left" :content="item['hintLeft']">
          <i class="el-icon-question MR10 pointer"/>
        </el-tooltip>
        <el-input
          v-model="result.form[item.prop]"
          v-if="item.type === 'input'"
          :placeholder="item.placeholder || `请输入${item.label}`"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :clearable="TRUE(item.clearable)"
          :readonly="item.readonly"
          :disabled="DISABLED(item,result.form)"
          :size="item.size || size"
          :maxlength="item.maxlength || undefined"
          :minlength="item.minlength || undefined"
          :type="item['showType'] || 'text'"
          :show-password="FALSE(item.showPassword || item['showType'] === 'password')"
          :show-word-limit="FALSE(item.showWordLimit)"
          @blur="blur($event,item)"
          @change="change(item)"
          @input="input($event,item)"
          @clear="clear($event, item)"
          @focus="focus($event, item)"
          @keyup.enter="enter(item)"
          @keyup="keyup(item)"
          @keydown="keydown(item)"
        />
        <el-input-number
          v-if="['number','inputNumber'].includes(item.type)"
          v-model="result.form[item.prop]"
          :placeholder="item.placeholder || `请输入${item.label}`"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :class="item.type === 'number' ? 'el-input-number-align-left' : ''"
          :clearable="TRUE(item.clearable)"
          :disabled="DISABLED(item, result.form)"
          :size="item.size || size"
          :min="item.min || 0"
          :max="item.max"
          :precision="item.precision"
          :step="item.step"
          :step-strictly="item.stepStrictly"
          :controls="item.type === 'number' ? false : TRUE(item.controls)"
          :controls-position="item.controlsPosition"
          @blur="blur($event,item)"
          @change="change(item)"
          @input="input($event,item)"
          @focus="focus($event, item)"
          @keyup.enter="enter(item)"
          @keyup="keyup(item)"
          @keydown="keydown(item)"
        />
        <el-input
          type="textarea"
          v-if="item.type === 'textarea'"
          v-model="result.form[item.prop]"
          :placeholder="item.placeholder || `请输入${item.label}`"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :clearable="TRUE(item.clearable)"
          :show-word-limit="FALSE(item.showWordLimit)"
          :disabled="DISABLED(item, result.form)"
          :readonly="item.readonly"
          :size="item.size || size"
          :rows="item.row || 2"
          @blur="blur($event,item)"
          @change="change(item)"
          @input="input($event,item)"
          @focus="focus($event, item)"
          @keyup.enter="enter(item)"
          @keyup="keyup(item)"
          @keydown="keydown(item)"
        />
        <el-select
          filterable
          default-first-option
          v-model="result.form[item.prop]"
          v-if="item.type === 'select'"
          @change="change(item)"
          @visible-change="visibleChange($event,item)"
          @blur="blur($event,item)"
          :popper-append-to-body="popperAppendToBody"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :clearable="TRUE(item.clearable)"
          :disabled="DISABLED(item, result.form)"
          :allow-create="FALSE(item.allowCreate)"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :multiple="FALSE(item.multiple)"
          :value-key="item.valueKey"
          :size="item.size || size"
          @clear="clear($event, item)"
          @focus="focus($event, item)"
        >
          <el-option
            v-for="val in item.option"
            :key="val[item['optionKey']] || val.index"
            :label="selectLabel(item,val)"
            :disabled="val.disabled"
            :value="selectValue(item,val)"
          />
        </el-select>
        <el-cascader
          v-model="result.form[item.prop]"
          v-if="item.type === 'cascader'"
          :ref="item.ref"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :options="item.option"
          :key="timeStamp(item.key)"
          :separator="item.separator"
          :collapse-tags="FALSE(item['collapseTags'])"
          :size="item.size || size"
          :disabled="DISABLED(item, result.form)"
          :debounce="item.debounce"
          :clearable="TRUE(item.clearable)"
          :props="item.props"
          filterable
          @change="change(item)"
          @blur="blur($event,item)"
          @focus="focus($event, item)"
        />
        <el-cascader-panel
          v-if="item.type === 'cascader-panel'"
          :ref="item.ref"
          :key="timeStamp(item.key)"
          v-model="result.form[item.prop]"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :options="item.option"
          :separator="item.separator"
          :collapse-tags="item.collapseTags"
          :size="item.size || size"
          :disabled="DISABLED(item, result.form)"
          :debounce="item.debounce"
          :clearable="TRUE(item.clearable)"
          :props="item.props"
          filterable
          @change="change(item)"
          @focus="focus($event, item)"
          @blur="blur($event, item)"
        />
        <el-time-picker
          v-model="result.form[item.prop]"
          v-if="item.type === 'time'"
          :format="item.format || valueFormat(item.type)"
          :value-format="item.valueFormat || valueFormat(item.type)"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :clearable="TRUE(item.clearable)"
          :disabled="DISABLED(item, result.form)"
          :readonly="item.readonly"
          :size="item.size || size"
          @blur="blur($event,item)"
          @focus="focus($event, item)"
          @change="change(item)"
        />
        <el-time-picker
          is-range
          v-model="range[item['startProp'] + item['endProp']]"
          v-if="item.type === 'timerange'"
          range-separator="至"
          :format="item.format || valueFormat(item.type)"
          :value-format="item.valueFormat || valueFormat(item.type)"
          :start-placeholder="item.startPlaceholder || '开始时间'"
          :end-placeholder="item.endPlaceholder || '结束时间'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :clearable="TRUE(item.clearable)"
          :readonly="item.readonly"
          :disabled="DISABLED(item, result.form)"
          :size="item.size || size"
          @blur="blur($event,item)"
          @focus="focus($event, item)"
          @change="rangeChange(item)"
        />
        <el-date-picker
          v-model="result.form[item.prop]"
          v-if="['year','years','month','months','date','dates','datetime'].includes(item.type)"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :picker-options="item['pickerOptions']"
          :clearable="TRUE(item.clearable)"
          :size="item.size || size"
          :default-time="item.defaultTime || '00:00:00'"
          :format="item.format || valueFormat(item.type)"
          :value-format="item.valueFormat || valueFormat(item.type)"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :readonly="item.readonly"
          :disabled="DISABLED(item, result.form)"
          :type="item.type"
          @change="change(item)"
          @blur="blur($event,item)"
          @focus="focus($event, item)"
        />
        <el-date-picker
          v-model="range[item['startProp'] + item['endProp']]"
          v-if="['daterange', 'datetimerange', 'monthrange'].includes(item.type)"
          @blur="blur($event,item)"
          @focus="focus($event, item)"
          @change="rangeChange(item)"
          range-separator="至"
          :start-placeholder="item.startPlaceholder || '开始日期'"
          :end-placeholder="item.endPlaceholder || '结束日期'"
          :picker-options="item['pickerOptions']"
          :clearable="TRUE(item.clearable)"
          :readonly="item.readonly"
          :disabled="DISABLED(item, result.form)"
          :size="item.size || size"
          :default-time="[item['defaultStartTime'],item['defaultEndTime']] || ['00:00:00', '00:00:00']"
          :format="item.format || valueFormat(item.type)"
          :value-format="item.valueFormat || valueFormat(item.type)"
          :type="item.type"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
        />
        <div
          class="align-left"
          v-if="item.type === 'switch'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
        >
          <el-switch
            v-model="result.form[item.prop]"
            @change="change(item)"
            :disabled="DISABLED(item, result.form)"
            :active-text="item['activeText']"
            :inactive-text="item['inactiveText']"
            :active-value="item['activeValue']"
            :inactive-value="item['inactiveValue']"
            :active-color="item['activeColor']"
            :inactive-color="item['inactiveColor']"
            :active-icon-class="item['activeIconClass']"
            :inactive-icon-class="item['inactiveIconClass']"
            :width="item['width']"
          />
        </div>
        <span
          v-if="item.type ==='span'"
          style="display: inline-flex;line-height: normal;"
          :class="item['textClassName']"
          :style="{'color':item.color,'width':VW(item.itemWidth) || VW(itemWidth)}"
          @click="btnClick(item)"
        >
          {{ item.prop ? result.form[item.prop] : item.content }}
        </span>
        <div
          class="align-left"
          v-if="item.type ==='button'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
        >
          <el-button
            @click="btnClick(item)"
            @mouseover.native="btnMouseover(item)"
            :type="item['btnType'] || 'primary'"
            :size="item.size || size"
            :disabled="DISABLED(item, result.form)"
            :plain="item.plain"
            :round="FALSE(item.round)"
            :circle="FALSE(item.circle)"
            :icon="item.icon"
          >
            {{ item.content }}
          </el-button>
        </div>
        <h-upload
          v-if="item.type ==='upload'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :show-type="item.showType"
          :file-type="item.fileType"
          :value.sync="result.form[item.prop]"
          :limit="item.limit"
          :disabled="DISABLED(item, result.form)"
          :headers="item.headers"
          :data="item.data"
          :size="item.size || size"
          :imgCheck="item.imgCheck"
          :tip="item.tip || undefined"
          :action="item.action"
          :upload-text="item.uploadText"
          :multiple="FALSE(item.multiple)"
          :show-file-list="TRUE(item.showFileList)"
          :file-size="item.fileSize"
          @success="uploadSuccess($event,item)"
          @remove="uploadRemove($event,item)"
        />
        <h-preview
          v-if="item.type ==='preview'"
          :url="result.form[item.prop]"
          :url-list="item.urlList"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :width="item.width"
          :height="item.height"
        />
        <el-radio-group
          v-model="result.form[item.prop]"
          v-if="item.type ==='radio'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :size="item.size || size"
          :fill="item.fill"
          :text-color="item.textColor"
          :disabled="DISABLED(item, result.form)"
          @input="input($event,item)"
        >
          <div v-if="!item.button">
            <el-radio
              v-for="val in item.option"
              :key="val.index"
              :label="val[item['optionKey']] || val"
              :border="FALSE(item.border)"
              :disabled="val.disabled"
            >
              {{ val[item["optionVal"]] || val }}
            </el-radio>
          </div>
          <div v-if="item.button">
            <el-radio-button
              v-for="val in item.option"
              :key="val.index"
              :label="val[item['optionKey']] || val"
              :disabled="val.disabled"
            >
              {{ val[item["optionVal"]] || val }}
            </el-radio-button>
          </div>
        </el-radio-group>
        <el-checkbox-group
          v-model="result.form[item.prop]"
          v-if="item.type ==='checkbox'"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :size="item.size || size"
          :fill="item.fill"
          :min="item.min"
          :max="item.max"
          :text-color="item.textColor"
          :disabled="DISABLED(item, result.form)"
          @change="change(item)"
        >
          <div v-if="!item.button">
            <el-checkbox
              v-for="val in item.option"
              :key="val.index"
              :label="val[item['optionKey']] || val"
              :border="FALSE(item.border)"
              :disabled="val.disabled"
              :checked="val.checked"
            >
              {{ val[item["optionVal"]] || val }}
            </el-checkbox>
          </div>
          <div v-if="item.button">
            <el-checkbox-button
              v-for="val in item.option"
              :key="val.index"
              :label="val[item['optionKey']] || val"
              :disabled="val.disabled"
              :checked="val.checked"
            >
              {{ val[item["optionVal"]] || val }}
            </el-checkbox-button>
          </div>
        </el-checkbox-group>
        <el-slider
          v-if="item.type ==='slider'"
          v-model="result.form[item.prop]"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :disabled="DISABLED(item, result.form)"
          :height="item.height"
          :vertical="FALSE(item.vertical)"
          :range="FALSE(item.range)"
          :min="item.min || 0"
          :max="item.max || 100"
          :show-input="FALSE(item.showInput)"
          :input-size="item.inputSize || size"
          :debounce="item.debounce || 300"
          :tooltip-class="item.tooltipClass"
          :show-input-controls="FALSE(item.showInputControls)"
          :show-stops="FALSE(item.showStops)"
          :show-tooltip="FALSE(item['tooltip'])"
          :format-tooltip="item.formatTooltip"
          :step="item.step || 1"
          :marks="item.marks"
          @change="change(item)"
          @input="input($event,item)"
        />
        <el-rate
          v-if="item.type ==='rate'"
          v-model="result.form[item.prop]"
          :class="`MT${item.top || 11}`"
          :style="{'width':VW(item.itemWidth) || VW(itemWidth)}"
          :colors="item.colors"
          :void-color="item.voidColor"
          :disabled-void-color="item.disabledVoidColor"
          :show-text="FALSE(item.showText)"
          :text-color="item.textColor"
          :texts="item.texts"
          :icon-classes="item.icon"
          :void-icon-class="item['voidIcon']"
          :disabled-void-icon-class="item['disabledVoidIcon']"
          :show-score="FALSE(item.showScore)"
          :allow-half="FALSE(item.allowHalf)"
          :disabled="DISABLED(item, result.form)"
          :low-threshold="item.lowThreshold || 2"
          :high-threshold="item.highThreshold || 4"
          score-template="{value}"
          @change="change(item)"
        />
        <div v-if="item.type ==='divider'" :style="{'width':VW(item.itemWidth) || VW(itemWidth)}">
          <el-divider
            :direction="item.vertical ?  'vertical' : 'horizontal'"
            :content-position="item.contentPosition"
          >
            <i v-if="!item['iconPosition'] || item['iconPosition'] === 'left'" :class="item.icon"/>
            {{ item.prop ? result.form[item.prop] : item.content }}
            <i v-if="item['iconPosition'] === 'right'" :class="item.icon"/>
          </el-divider>
        </div>
        <el-tooltip v-if="item['hintRight']" placement="right" :content="item['hintRight']">
          <i class="el-icon-question ML10 pointer"/>
        </el-tooltip>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import {type} from "otb-module/src/utils/tool";

export default {
  name: "hForm",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      required: true
    },
    center: {
      type: Boolean
    },
    rules: {
      type: Object,
      required: false
    },
    option: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    formWidth: {
      type: [String, Number],
      required: false,
      default: "fit-content"
    },
    formBGC: {
      type: String,
      required: false
    },
    itemWidth: {
      type: [String, Number],
      required: false,
      default: "10vw"
    },
    labelBold: {
      type: Boolean,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: "small"
    },
    className: {
      type: String,
      required: false
    },
    labelWidth: {
      type: [String, Number],
      required: false,
      default: "auto"
    },
    labelPosition: {
      type: String,
      required: false,
      default: "right"
    },
    refForm: {
      type: String,
      required: false,
      default: "hForm"
    },
    draggable: {
      type: Boolean,
      required: false
    },
    author: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      range: {},
      result: {
        option: undefined,
        form: {}
      }
    };
  },
  watch: {
    form: {
      handler(newVal) {
        this.result.form = newVal;
        this.hasRange();
      },
      deep: true,
      immediate: true
    },
    option: {
      handler(newVal) {
        this.setAuthor(newVal);
      },
      deep: true,
      immediate: true
    },
    disabled: {
      handler(newVal) {
        if (newVal) {
          this.result.option = JSON.parse(JSON.stringify(this.option));
          for (let item of this.result.option) {
            item.disabled = true;
          }
        } else {
          this.result.option = undefined;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    valueFormat() {
      return type => {
        switch (type) {
          case "year":
            return "yyyy";
          case "years":
            return "yyyy";
          case "time":
            return "HH:mm:ss";
          case "month":
            return "yyyy-MM";
          case "months":
            return "yyyy-MM";
          case "date":
            return "yyyy-MM-dd";
          case "dates":
            return "yyyy-MM-dd";
          case "timerange":
            return "HH:mm:ss";
          case "daterange":
            return "yyyy-MM-dd";
          case "monthrange":
            return "yyyy-MM";
          case "datetime":
            return "yyyy-MM-dd HH:mm:ss";
          case "datetimerange":
            return "yyyy-MM-dd HH:mm:ss";
        }
      };
    },
    itemClass() {
      return item => {
        let className = this.className;
        if (this.labelBold) {
          return item.className ? `${item.className} bolder` : className ? `${className} bolder` : "bolder ML20";
        } else {
          return item.className || className || "ML20";
        }
      };
    },
    DISABLED() {
      return (item, row) => {
        if (type(item.disabled) === "Boolean") {
          return item.disabled;
        }
        if (type(item.disabledProp) === "String") {
          return Boolean(row[item.disabledProp]);
        }
      };
    },
    TRUE() {
      return item => {
        return [true, false].includes(item) ? item : true;
      };
    },
    FALSE() {
      return item => {
        return [true, false].includes(item) ? item : false;
      };
    },
    VW() {
      return v => {
        if (type(v) === "Number") return v + "vw";
        return v;
      };
    },
    timeStamp() {
      return item => {
        return item ? new Date().getTime() : undefined;
      };
    },
    selectValue() {
      return (item, val) => {
        if (item.valueKey) return val;
        if (item['optionKey']) {
          return val[item['optionKey']];
        } else {
          return val;
        }
      }
    },
    selectLabel() {
      return (item, val) => {
        if (type(item['optionVal']) === "Array") {
          const symbol = item.symbol || " / ";
          let labelList = [];
          for (let prop of item['optionVal']) {
            labelList.push(val[prop]);
          }
          return labelList.join(symbol);
        }
        return val[item['optionVal']] || val;
      }
    },
  },
  methods: {
    setAuthor(list) {
      if (this.author["btnKey"] && this.author["btnAuthor"]) {
        for (let item of list) {
          let boolean = type(item.show) === "Boolean";
          if (((boolean && item.show) || !boolean) && item["key"]) {
            item.show = this.author["btnAuthor"].some(v => v[this.author["btnKey"]] === item.key);
          }
        }
      }
    },
    rangeChange(item) {
      let list = this.range[item["startProp"] + item["endProp"]];
      if (list && list.length > 0) {
        this.result.form[item["startProp"]] = list[0];
        this.result.form[item["endProp"]] = list[1];
      } else {
        delete this.result.form[item["startProp"]];
        delete this.result.form[item["endProp"]];
      }

      this.change(item);
    },
    // 回显时间段
    hasRange() {
      for (let item of this.option) {
        if (["timerange", "daterange", "datetimerange", "monthrange"].includes(item.type)) {
          this.$set(this.range, item["startProp"] + item["endProp"], []);

          if (this.result.form[item["startProp"]] && this.result.form[item["endProp"]]) {
            let list = this.range[item["startProp"] + item["endProp"]];
            list[0] = this.result.form[item["startProp"]];
            list[1] = this.result.form[item["endProp"]];
          }
        }
      }
    },
    change(v) {
      if (v && type(v.change) === "Function") v.change(this.result.form);
      this.$emit("change", this.result.form);
    },
    visibleChange(e, v) {
      if (v && type(v.visibleChange) === "Function") v.visibleChange(e);
      this.$emit("visibleChange", e);
    },
    blur(e, v) {
      if (v && type(v.blur) === "Function") v.blur(e);
      this.$emit("blur", e);
    },
    clear(e, o) {
      if (type(o.clear) === "Function") o.clear(e)
      this.$emit("clear", e)
    },
    focus(e, o) {
      if (type(o.focus) === "Function") o.focus(e)
      this.$emit("focus", e)
    },
    enter(o) {
      if (type(o.enter) === "Function") o.enter(this.result.form)
      this.$emit("enter", this.result.form)
    },
    keyup(o) {
      if (type(o.keyup) === "Function") o.keyup(this.result.form)
      this.$emit("keyup", this.result.form)
    },
    keydown(o) {
      if (type(o.keydown) === "Function") o.keydown(this.result.form)
      this.$emit("keydown", this.result.form)
    },
    input(e, v) {
      if (v && type(v.input) === "Function") v.input(e);
      this.$emit("input", e);
    },
    uploadSuccess(e, v) {
      if (v && type(v.success) === "Function") v.success(e);
      this.$emit("uploadSuccess", e);
    },
    uploadRemove(e, v) {
      if (v && type(v.remove) === "Function") v.remove(e);
      this.$emit("uploadRemove", e);
    },
    dragend(e, v, i) {
      this.$emit("dragend", e, v, i);
    },
    dragenter(e, v, i) {
      this.$emit("dragenter", e, v, i);
    },
    dragstart(e, v, i) {
      this.$emit("dragstart", e, v, i);
    },
    click(e, v, i) {
      this.$emit("click", e, v, i);
    },
    btnClick(v) {
      if (v && type(v.click) === "Function") v.click(this.result.form);
      this.$emit("btnClick", this.result.form);
    },
    btnMouseover(v) {
      if (v && type(v.mouseover) === "Function") v.mouseover(this.result.form);
      this.$emit("btnMouseover", this.result.form);
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  display: flex;
  flex-direction: row;

  .el-form-item__content {
    margin-left: 5px !important;
  }
}
</style>
